import restApi from "@plannel/services/utils/rest-api";

/*
 * Sales Status Dashboard 데이터 서비스.
 * 독립 DW(z_mv_fact_sales_actual_month) 기반 백엔드 조회.
 *   백엔드: GET /api/dashboard-dw/sales-status (SalesStatusDashboardController)
 * 참고: saas-application/docs/sql/dw/DASHBOARD_GUIDE.md
 */
const get = (params) => restApi.get("/api/dashboard-dw/sales-status", { params });

const salesStatusService = { get };

export default salesStatusService;
